"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var StyledInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var StyledLabel = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Toggle = function (_a) {
    var label = _a.label, props = __rest(_a, ["label"]);
    var id = label + "-toggle";
    var css = {
        label: 'custom-control-label',
        input: 'custom-control-input',
        button: "btn float-right mr-2 " + props.className,
    };
    return (jsx_runtime_1.jsx("div", __assign({ className: css.button }, { children: jsx_runtime_1.jsxs("div", __assign({ className: "custom-control custom-switch" }, { children: [jsx_runtime_1.jsx(StyledInput, __assign({}, props, { type: "checkbox", className: css.input, id: id }), void 0),
                jsx_runtime_1.jsx(StyledLabel, __assign({ className: css.label, htmlFor: id }, { children: label }), void 0)] }), void 0) }), void 0));
};
exports.Toggle = Toggle;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map